import React from "react";
import { AppBar, Grid, IconButton, Tooltip } from "@mui/material";
import { ExitToAppRounded } from "@mui/icons-material";
import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";

const Header = () => {
  const { instance } = useMsal();

  const handleLogout = (logoutType) => {
    if (logoutType === "popup") {
      instance.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/",
      });
    } else if (logoutType === "redirect") {
      instance.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    }
  };
  return (
    <React.Fragment>
      <AppBar
        position="sticky"
        color="inherit"
        style={{
          height: "auto",
          backgroundColor: "white",
        }}
      >
        <Grid
          container
          style={{ height: "68px", width: "inherit" }}
          color="primary"
        >
          <Grid item xs="auto" id="eoclogo">
            <a href="/">
              <img
                style={{ maxWidth: "92%", height: "auto" }}
                src="/img/eoclogotrans.png"
                alt="EOC"
              />
              <div
                style={{
                  content: "",
                  display: "inline-block",
                  width: "10px",
                  margin: "19px 10px",
                  height: "40px",
                  backgroundColor: "#e50071",
                  transform: "skew(-15deg)",
                }}
              />
            </a>
          </Grid>
          <AuthenticatedTemplate>
            <Grid
              container
              item
              xs
              style={{
                height: "68px",
                display: "flex",
                justifyContent: "flex-end",
              }}
              alignItems="center"
            >
              <Tooltip title="logout" placement="left">
                <Grid item xs="auto" id={"logout_Link"}>
                  <IconButton
                    edge="start"
                    onClick={(e) => {
                      handleLogout("popup");
                    }}
                  >
                    <ExitToAppRounded color="primary" fontSize="large" />
                  </IconButton>
                </Grid>
              </Tooltip>
            </Grid>
          </AuthenticatedTemplate>
        </Grid>
      </AppBar>
      <div style={{ height: "35px" }}></div>
    </React.Fragment>
  );
};

export default Header;
